import React from 'react'
import { BiLoaderAlt } from 'react-icons/bi'
import { useSelector } from 'react-redux'

const SuspensePageLoading = () => {
    const {sidebar} = useSelector(state => state.ui)
  return (
    <div className={`h-screen w-full bg-white flex items-center justify-center ${sidebar ? "pl-[250px]" : ""}`}>
        <BiLoaderAlt className='text-7xl animate-spin'/>
    </div>
  )
}

export default SuspensePageLoading